import { useTranslation } from 'react-i18next';
import { useRouteSidePanelStore } from '@/shared/stores/side-panel-store';
import type { AIContextMenu } from '@/widgets/right-side-menu/lib/types';
import { SideMenuHeader } from '@/widgets/right-side-menu/ui/SideMenuHeader';

type Props = {
  aiContextMenu: undefined | AIContextMenu;
  setAiContextMenu: (context: undefined | AIContextMenu) => void;
};

export const ProjectCreateAIChatHeader = ({ aiContextMenu, setAiContextMenu }: Props) => {
  const { t } = useTranslation();
  const requestClose = useRouteSidePanelStore((state) => state.requestClose);
  const requestAction = useRouteSidePanelStore((state) => state.requestAction);

  const isProjectFormPage =
    aiContextMenu?.route === 'projectCreate' || aiContextMenu?.route === 'projectEdit';

  const title = ((): string => {
    const defaultTitle = t('ai.common.assistant-title');
    if (!isProjectFormPage) {
      return defaultTitle;
    }
    switch (aiContextMenu?.mode) {
      case 'createFromPdf':
        return aiContextMenu?.route === 'projectEdit'
          ? t('ai.update-from-pdf.title')
          : t('ai.create-from-pdf.title');
      default:
        return defaultTitle;
    }
  })();

  return (
    <SideMenuHeader
      title={title}
      onClose={requestClose}
      onBack={
        isProjectFormPage && aiContextMenu?.mode === 'createFromPdf'
          ? () => {
              requestAction(() => setAiContextMenu(undefined));
            }
          : undefined
      }
    />
  );
};
